import {
  AuthConditionResponseTypes,
  AuthorizedComponent,
  HIDE,
} from '@readcloud/component-library';
import * as React from 'react';
import { authSelectors } from '@readcloud/state';
import { useSelector } from 'react-redux';

interface IAuthorizedProps {
  requiredPermissions: string[][];
  requiredAccess: { read?: boolean; write?: boolean };
  action?: AuthConditionResponseTypes;
  hiddenComponent?: JSX.Element;
  redirectPath?: string;
  children?: React.ReactNode;
}

export const Authorized: React.FunctionComponent<IAuthorizedProps> = ({
  action = HIDE,
  ...props
}) => {
  const permissions = useSelector(authSelectors.getUserPermissions);
  return (
    <AuthorizedComponent
      userPermissions={permissions}
      action={action}
      {...props}
    >
      {props.children}
    </AuthorizedComponent>
  );
};
